import { render, staticRenderFns } from "./KitPanelItem.vue?vue&type=template&id=ddf9f578&scoped=true&"
import script from "./KitPanelItem.vue?vue&type=script&lang=js&"
export * from "./KitPanelItem.vue?vue&type=script&lang=js&"
import style0 from "./KitPanelItem.vue?vue&type=style&index=0&id=ddf9f578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf9f578",
  null
  
)

export default component.exports